const ContactItem = ({ iconClass, title, content, bgImage }) => (
    <div className="col-12 col-sm-12 col-md-4 col-lg-3 mb-4">
        <div className="contact-box " >
            <div className={`icon-container`}
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '92px',
                    height: '90px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                }}>
                {iconClass}
            </div>
            <h4>{title}</h4>
            <p className="col-lg-12 col-sm-12 col-12 ">{content}</p>
        </div>
    </div>
);

export default ContactItem;


// ${title.toLowerCase().replace(/\s+/g, '-')}